import { GUIGameState } from '../../types/game-types';
import { useCurrencyStore } from '../zustand/useCurrencyStore';

export const clickFarmReducer = (state: GUIGameState) => {
  useCurrencyStore.getState().addFood(1);
  console.log('click farm', useCurrencyStore.getState().food);

  return state;
};
